// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import config from "@/config";
import installPlugin from "@/plugin";
import "./index.less";
import "@/assets/icons/iconfont.css";
import VueClipboard from "vue-clipboard2";

import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";

import "@/components/basic-filter/index.js";

/* 引入公共js*/
import common from '@/assets/js/common.js'
Vue.prototype.common=common;

import iView from "iview";
import "iview/dist/styles/iview.css";

import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";

import qs from "qs";

import cookies from "js-cookie";
import moment from "moment";
import lodash from "lodash";
import debounce from "lodash.debounce";
import throttle from "lodash.throttle";
import merge from "lodash.merge";

import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
Vue.use(mavonEditor);

import TreeSelect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

Vue.use(preview);

Vue.use(VXETable);

Vue.use(iView);

Vue.use(VueClipboard);
import 'echarts';
import VueECharts from 'vue-echarts';
Vue.component('v-chart', VueECharts)
Vue.component('TreeSelect', TreeSelect)
/**
 * @description 注册admin内置插件
 */
installPlugin(Vue);
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false;
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config;
Vue.prototype.$qs = qs;

Vue.prototype.$moment = moment;
Vue.prototype.$_ = lodash;
Vue.prototype.$debounce = debounce;
Vue.prototype.$throttle = throttle;
Vue.prototype.$merge = merge;
Vue.prototype.$cookies = cookies;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js